<template>
  <div class="rt-vehicle-selector">
    <el-input 
      readonly 
      :placeholder="placeholder || '请选择规格型号'" 
      :disabled="disabled" 
      v-model="vehicleValue" 
      @focus="showVehicleDialog">
      <i slot="suffix" class="el-input__icon el-icon-search" @click="showVehicleDialog"></i>
    </el-input>
    <rt-vehicle-dialog 
      ref="vehicleDialog"
      :data-source="dataSource"
      :display-fields="displayFields"
      @vehicle-selected="handleVehicleSelected">
    </rt-vehicle-dialog>
  </div>
</template>

<script>
import RtVehicleDialog from "./vehicle-dialog";

export default {
  name: "RtVehicleSelector",
  props: {
    value: {
      type: String,
      required: false,
      default: ""
    },
    disabled: Boolean,
    dataSource: {
      type: Array,
      default: () => []
    },
    displayFields: {
      type: Array,
      default: () => [
        { name: "Vehicle", label: "规格型号" },
        { name: "new_product_name", label: "产品名称" },
        { name: "new_product_line", label: "产品线" }
      ]
    },
    placeholder: String
  },
  components: {
    "rt-vehicle-dialog": RtVehicleDialog
  },
  data() {
    return {
      vehicleValue: ""
    };
  },
  watch: {
    value(newValue) {
      this.vehicleValue = newValue || "";
    }
  },
  mounted() {
    if (this.value) {
      this.vehicleValue = this.value;
    }
  },
  methods: {
    showVehicleDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.vehicleDialog.show();
    },
    handleVehicleSelected(val) {
      this.vehicleValue = val;
      this.$emit("input", val);
      this.$emit("change", val);
    }
  }
};
</script>

<style scoped>
.rt-vehicle-selector {
  width: 100%;
}

.el-input__icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// vehicle-selector.vue?f6478440